/**
 * WizardStepRemuneration — Step 3: Salaire & Indemnités journalières.
 * Extracted from ContractWizard.jsx for maintainability.
 */
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Euro, FileText } from 'lucide-react';

export const WizardStepRemuneration = ({ data, onChange, children }) => (
  <div className="space-y-5">
    <div className="space-y-3">
      <h3 className="font-semibold text-sm flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
        <Euro className="h-4 w-4" style={{ color: 'var(--primary-400)' }} /> Salaire
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="space-y-1.5">
          <Label>Taux horaire net (€) *</Label>
          <Input type="number" step="0.01" min="0.01" value={data.hourly_rate} onChange={(e) => onChange({ ...data, hourly_rate: e.target.value })} placeholder="3.50" required data-testid="wizard-hourly-rate" />
          <p className="text-xs text-[var(--text-tertiary)]">Minimum SMIC horaire</p>
        </div>
        <div className="space-y-1.5">
          <Label>Mode de paiement</Label>
          <Select value={data.payment_method} onValueChange={(val) => onChange({ ...data, payment_method: val })}>
            <SelectTrigger data-testid="wizard-payment-method"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="virement">Virement bancaire</SelectItem>
              <SelectItem value="cheque">Chèque</SelectItem>
              <SelectItem value="cesu">CESU</SelectItem>
              <SelectItem value="especes">Espèces</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label>Majoration &gt;45h/sem (%)</Label>
          <Input type="number" step="1" min="0" value={data.overtime_rate} onChange={(e) => onChange({ ...data, overtime_rate: e.target.value })} placeholder="10" data-testid="wizard-overtime-rate" />
        </div>
      </div>
    </div>
    <Separator />
    <div className="space-y-3">
      <h3 className="font-semibold text-sm flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
        <FileText className="h-4 w-4" style={{ color: 'var(--primary-400)' }} /> Indemnités journalières
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <div>
          <Label>Entretien (€/jour) *</Label>
          <Input type="number" step="0.01" min="0" value={data.daily_allowance} onChange={(e) => onChange({ ...data, daily_allowance: e.target.value })} placeholder="3.83" required data-testid="wizard-daily-allowance" />
          <p className="text-xs mt-1 text-[var(--text-tertiary)]">Min 2.65€, ref 9h = 3.83€</p>
        </div>
        <div>
          <Label>Repas (€/jour)</Label>
          <Input type="number" step="0.01" min="0" value={data.meal_price} onChange={(e) => onChange({ ...data, meal_price: e.target.value })} placeholder="4.50" data-testid="wizard-meal-price" />
        </div>
        <div>
          <Label>Goûter (€/jour)</Label>
          <Input type="number" step="0.01" min="0" value={data.snack_price} onChange={(e) => onChange({ ...data, snack_price: e.target.value })} placeholder="2.00" data-testid="wizard-snack-price" />
        </div>
        <div>
          <Label>Kilométrique (€/jour)</Label>
          <Input type="number" step="0.01" min="0" value={data.km_allowance} onChange={(e) => onChange({ ...data, km_allowance: e.target.value })} placeholder="0.00" data-testid="wizard-km-allowance" />
        </div>
      </div>
    </div>
    {children}
  </div>
);
